var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08742 0.343612L7 5.25599L11.8871 0.369064C11.9951 0.254168 12.1251 0.162254 12.2695 0.0988357C12.4138 0.0354172 12.5695 0.00179995 12.7271 0C13.0646 0 13.3884 0.134081 13.627 0.372746C13.8657 0.611412 13.9998 0.935112 13.9998 1.27264C14.0028 1.42866 13.9738 1.58365 13.9147 1.72809C13.8556 1.87253 13.7676 2.00336 13.6562 2.11258L8.7054 6.9995L13.6562 11.9501C13.8659 12.1553 13.9889 12.4331 13.9998 12.7264C13.9998 13.0639 13.8657 13.3876 13.627 13.6262C13.3884 13.8649 13.0646 13.999 12.7271 13.999C12.5649 14.0057 12.4031 13.9787 12.2519 13.9195C12.1007 13.8603 11.9635 13.7704 11.8489 13.6554L7 8.74301L2.10015 13.6427C1.99261 13.7537 1.86414 13.8424 1.72216 13.9036C1.58017 13.9647 1.42748 13.9972 1.2729 13.999C0.935358 13.999 0.611645 13.8649 0.372969 13.6262C0.134294 13.3876 0.000207075 13.0639 0.000207075 12.7264C-0.00276019 12.5703 0.0261896 12.4153 0.0852799 12.2709C0.14437 12.1265 0.232355 11.9956 0.343833 11.8864L5.2946 6.9995L0.343833 2.04894C0.134075 1.84374 0.0110754 1.56587 0.000207075 1.27264C0.000207075 0.935112 0.134294 0.611412 0.372969 0.372746C0.611645 0.134081 0.935358 0 1.2729 0C1.57834 0.00381791 1.87106 0.127264 2.08742 0.343612Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.479d054789f450f3f466644b412751bc.svg";
export { ForwardRef as ReactComponent };